import React, { useId } from 'react';
import { APP_NAME } from '../utils/branding';
import logo from '../assets/branding/photochap-logo.png';
import metrics from '../assets/branding/photochap-logo.metrics.json';
import './BrandLogo.css';

export default function BrandLogo({ className = '', tone = 'dark' }) {
  const wordmarkId = `photochap-wordmark-${useId().replace(/:/g, '')}`;
  const { x, y, contentWidth, contentHeight, width, height, wordmarkX } = metrics;

  return (
    <svg
      className={`photochap-logo ${className}`.trim()}
      viewBox={`${x} ${y} ${contentWidth} ${contentHeight}`}
      role="img"
      aria-label={APP_NAME}
      focusable="false"
    >
      <image href={logo} width={width} height={height} />
      {tone === 'light' && <>
        <defs>
          <clipPath id={wordmarkId}>
            <rect x={wordmarkX} y={y} width={x + contentWidth - wordmarkX} height={contentHeight} />
          </clipPath>
        </defs>
        <g clipPath={`url(#${wordmarkId})`}>
          <image className="photochap-logo__light-wordmark" href={logo} width={width} height={height} />
        </g>
      </>}
    </svg>
  );
}
